import {
  updateConnectionPolicy,
  type ConnectionAccessChoice,
  type ConnectionReadItem,
} from '../connection-read-access/api';
import type { CustomMcpConnection } from './api';

export type PendingConnectChoice = { id: string; choice: ConnectionAccessChoice };

/** The new connection's own grant, once that connection is connected; until then the choice waits. */
export function pendingGrant(items: CustomMcpConnection[], pending: PendingConnectChoice | null) {
  const created = items.find((item) => item.id === pending?.id);
  const read = created?.readAccess;
  // Only once the server is actually connected: a grant saved while it still waits for sign-in
  // is invalidated when the sign-in completes, and the choice would be lost.
  return pending && created?.status === 'connected' && read?.connectionId === pending.id
    ? read
    : null;
}

/** Applied once, to the created connection's own untouched grant; anything else stays on Ask. */
export async function applyConnectChoice(
  read: ConnectionReadItem,
  choice: ConnectionAccessChoice,
  fetchImpl?: typeof fetch,
): Promise<ConnectionReadItem | null> {
  if (!read.canSet || read.access.revision !== null || read.access.enabled || read.access.status)
    return null;
  try {
    return await updateConnectionPolicy(read, choice, true, fetchImpl);
  } catch {
    // Left on Ask: the card's Access row shows it and offers the choice again.
    return null;
  }
}
